import { StyledInteractiveVideoSummary } from './InteractiveVideoSummary.styled';
import { intersect } from '/src/modules/arrayUtils';
import { CheckOutlined } from '@ant-design/icons';
import { Button, Space, Divider } from 'antd';

export default function InteractiveVideoSummary({
  activityName,
  questions,
  answeredQuestions,
  onContinue,
  onRestart,
  canRestart,
}) {
  /* answeredQuestions.sort(
    (a, b) => (a.id == b.id ? a.correct - b.correct : a.id - b.id)
    // sort incorrect answers before correct ones when same id
  ); */
  const answeredQuestionsCount = intersect(questions, answeredQuestions).length;
  return (
    <StyledInteractiveVideoSummary>
      <div className="title">{activityName} Answers Summary</div>
      <Divider />
      <div className="summary-content">
        <div className="progress-feedback">
          {answeredQuestionsCount == questions.length
            ? 'Congratulations!! You answered all the questions.'
            : `You answered ${answeredQuestionsCount} of ${questions.length} questions.`}
        </div>
        <div className="correctness">
          You got right{' '}
          {answeredQuestions.reduce(
            (acc, answer) => (answer.correct ? acc + 1 : acc),
            0
          )}{' '}
          of them.
        </div>
        <div className="details">
          <div className="details-header">
            <div className="title">Question</div>
            <div className="answer-text">Your Answer</div>
            <div className="right-answer">Right Answer</div>
          </div>
          {answeredQuestions.map((answer, index) => (
            <div key={index} className="answer-detail">
              <div className="title">{answer.title}</div>
              {answer.correct ? (
                <>
                  <div className="correct-answer">{answer.selected}</div>

                  <div className="right-answer">
                    <CheckOutlined />
                  </div>
                </>
              ) : (
                <>
                  {' '}
                  <div className="answer-text">{answer.selected}</div>
                  <div className="right-answer">{answer.rightAnswer}</div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
      <Divider />
      <div className="actions">
        <Space>
          {canRestart && (
            <Button type="secondary" onClick={onRestart}>
              Restart Video
            </Button>
          )}
          <Button type="primary" onClick={onContinue}>
            Continue
          </Button>
        </Space>
      </div>
    </StyledInteractiveVideoSummary>
  );
}
